import popular_01 from "../assets/images/popular-01.jpg";
import popular_02 from "../assets/images/popular-02.jpg";
import popular_03 from "../assets/images/popular-03.jpg";
import popular_04 from "../assets/images/popular-04.jpg";
import popular_05 from "../assets/images/popular-05.jpg";
import popular_06 from "../assets/images/popular-06.jpg";
const MostPopularData = [
  {
    id: "most_popular_item-0",
    image: popular_01,
    title: "Fortnite",
    category: "Sandnox",
    rate: "3.8",
    download: "2.3M",
  },
  {
    id: "most_popular_item-1",
    image: popular_02,
    title: "PubG",
    category: "Stream-X",
    rate: "4.8",
    download: "1.1M",
  },
  {
    id: "most_popular_item-2",
    image: popular_03,
    title: "Dota2",
    category: "Legendary",
    rate: "2.7",
    download: "5.3M",
  },
  {
    id: "most_popular_item-3",
    image: popular_04,
    title: "CS-GO",
    category: "Battle5",
    rate: "3.9",
    download: "6.1M",
  },
  {
    id: "most_popular_item-4",
    image: popular_05,
    title: "MinCraft",
    category: "Legendary",
    rate: "1.8",
    download: "2.3M",
  },
  {
    id: "most_popular_item-5",
    image: popular_06,
    title: "Eagles Fly",
    category: "Matrix",
    rate: "2.6",
    download: "10.1M",
  },
  {
    id: "most_popular_item-6",
    image: popular_02,
    title: "Dota2",
    category: "Legendary",
    rate: "2.7",
    download: "5.3M",
  },
  {
    id: "most_popular_item-7",
    image: popular_05,
    title: "CS-GO",
    category: "Battle5",
    rate: "3.9",
    download: "6.1M",
  },
];

export default MostPopularData;
